var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_4640",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 23.8334C14.4229 23.8353 15.8322 23.5559 17.1468 23.0113C18.4614 22.4668 19.6554 21.6678 20.6602 20.6603C21.6677 19.6555 22.4667 18.4615 23.0112 17.1469C23.5558 15.8323 23.8351 14.423 23.8333 13.0001C23.8351 11.5772 23.5557 10.1679 23.0112 8.85332C22.4666 7.53872 21.6677 6.34469 20.6602 5.33984C19.6554 4.33236 18.4614 3.53338 17.1468 2.98884C15.8322 2.44429 14.4229 2.16491 13 2.16676C11.5771 2.16494 10.1678 2.44434 8.8532 2.98888C7.5386 3.53342 6.34457 4.33238 5.33972 5.33984C4.33226 6.34469 3.5333 7.53872 2.98876 8.85332C2.44421 10.1679 2.16482 11.5772 2.16664 13.0001C2.16479 14.423 2.44417 15.8323 2.98871 17.1469C3.53326 18.4615 4.33223 19.6555 5.33972 20.6603C6.34457 21.6678 7.5386 22.4668 8.8532 23.0113C10.1678 23.5558 11.5771 23.8352 13 23.8334Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 13L11.9166 16.25L18.4166 9.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_4640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H26V26H0V0Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.a309a0c2a74d6799987eff62ff936886.svg";
export { ForwardRef as ReactComponent };